export const commerceNameList: Record<number, { name: string; classes: string }> = {
  1: {
    name: '地精金库',
    classes: 'gold',
  },
  2: {
    name: '史莱姆保护协会',
    classes: 'unique',
  },
  3: {
    name: '传说武库',
    classes: 'legend',
  },
  4: {
    name: '名钻商会',
    classes: 'diamond',
  },
  5: {
    name: '魔龙教会',
    classes: 'hp',
  },
}

export const buyCountBtn = [100, 1000, 5000]
